/**
 * Implements the report customization modal.
 */

import Backbone from "backbone";
import Sortable from "sortablejs";
import GenericModal from "../generic/modal/base";
import Form from "./form";
import Collection from "../../collections/columns-customizer";

const GenericModel = Backbone.Model.extend();

const DEFAULTS = {
  title: "Customize View",
};

class ReportCustomizer extends GenericModal {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  onBeforeRender() {
    // extract columns from report config
    const { columns, customColumns } = this.options.reportConfig;

    // create model
    this.model = this._createModel(this.options.reportConfig);

    // create collection
    this.collection = this._createCollection(columns, customColumns);

    // call superclass
    if (super.onBeforeRender) super.onBeforeRender();
  }

  // @Override
  onRender() {
    this.body.show(
      new Form({
        model: this.model,
        collection: this.collection,
      })
    );

    // call superclass
    if (super.onRender) super.onRender();
  }

  // @Override
  _onShow() {
    // make list group sortable
    const $el = this.$(".list-group");
    Sortable.create($el[0], {
      animation: 150,
    });

    // enable bootstrap tooltips
    this.$("[data-toggle=tooltip]").tooltip();

    // call superclass
    if (super._onShow) super._onShow();
  }

  _createModel(config) {
    return new GenericModel({
      _created: config.customColumnsCreated,
      route: config.route,
    });
  }

  _createCollection(columns = [], customColumns = []) {
    // create column collection
    const collection = new Collection(columns);

    // process custom columns
    if (!_.isEmpty(customColumns)) {
      let fauxSequence = 1000;

      // check selected columns
      const sequencedList = collection.map((column) => {
        let data = {};

        const found = _.indexOf(customColumns, column.getElementId());
        if (found > -1) {
          data = {
            checked: true,
            sequence: found,
            name: column.getNameOriginal(),
          };
        } else {
          data = {
            sequence: fauxSequence++,
          };
        }

        column.set(data);

        return column;
      });

      // update state
      collection.reset(sequencedList);
    } else {
      // check all visible columns
      collection.map((column) => {
        column.getVisible() && column.setChecked(true);
      });
    }

    // remove invisible columns
    const invisible = collection.where({ visible: false });
    if (invisible) {
      collection.remove(invisible);
    }

    // console.log(collection.toJSON());
    return collection;
  }
}

export { ReportCustomizer as default };
